export default __webpack_public_path__ + "static/14-07a31ee52681cd374d8acd02dd4841c8.png";